import React from "react";
import { useSelector } from "react-redux";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import CardTitle from "./CardTitle";
import { roundToX } from "../../common/common";

export default function StatsCard(props) {
    const laserData = useSelector(state => state.laserData);

    const renderTitle = (title, summary) => {
        if(summary.pointCount) {
            title += ` (Points: ${summary.pointCount})`;
        }
        return title; 
    }

    const renderHeader = (machine, motor) => {
        return(
            <>
                <Grid row xs={12}>
                    <Typography variant="inherit" sx={{display:"inline-flex", width:"20%"}}></Typography>
                    <Typography variant="inherit" sx={{display:"inline-flex", width:"40%", justifyContent:"center"}}>{renderTitle("Machine", machine)}</Typography>
                    <Typography variant="inherit" sx={{display:"inline-flex", width:"40%", justifyContent:"center"}}>{renderTitle("Motor", motor)}</Typography>
                </Grid>
                <Grid row xs={12}>
                    <Typography variant="inherit" sx={{display:"inline-flex", width:"20%"}}></Typography>
                    <Typography variant="inherit" sx={{display:"inline-flex", width:"20%", justifyContent:"right"}}>Std Dev</Typography>
                    <Typography variant="inherit" sx={{display:"inline-flex", width:"20%", justifyContent:"right"}}>R2</Typography>
                    <Typography variant="inherit" sx={{display:"inline-flex", width:"20%", justifyContent:"right"}}>Std Dev</Typography>
                    <Typography variant="inherit" sx={{display:"inline-flex", width:"20%", justifyContent:"right"}}>R2</Typography>
                </Grid>
            </>
        )
    }

    const renderStats = (machine, motor, dir) => {
        return(
            <Grid row xs={12}>
                <Typography variant="inherit" sx={{display:"inline-flex", width:"20%"}}>{(dir === "y" ? "Vertical" : "Horizontal")}</Typography>
                <Typography variant="inherit" sx={{display:"inline-flex", width:"20%", fontWeight: "bold", justifyContent:"right"}}>{`${roundToX(machine.standardDeviation[dir],4).toFixed(4)}`}</Typography>
                <Typography variant="inherit" sx={{display:"inline-flex", width:"20%", fontWeight: "bold", justifyContent:"right"}}>{`${roundToX(machine.rSquared[dir],4).toFixed(4)}`}</Typography>
                <Typography variant="inherit" sx={{display:"inline-flex", width:"20%", fontWeight: "bold", justifyContent:"right"}}>{`${roundToX(motor.standardDeviation[dir],4).toFixed(4)}`}</Typography>
                <Typography variant="inherit" sx={{display:"inline-flex", width:"20%", fontWeight: "bold", justifyContent:"right"}}>{`${roundToX(motor.rSquared[dir],4).toFixed(4)}`}</Typography>
            </Grid>
        )
    }

    return (
        <Card
            raised={false}
            variant="outlined" 
            sx={{paddingLeft:"16px", paddingRight:"16px", marginTop:"7px"}}
        >
            <CardTitle title="Statistics" />
            <CardContent className="shim-panel" >
                <Grid container>
                    {renderHeader(laserData.summary.machine, laserData.summary.motor)}
                    {renderStats(laserData.summary.machine, laserData.summary.motor, "y")}
                    {renderStats(laserData.summary.machine, laserData.summary.motor, "z")}
                </Grid>
            </CardContent>
        </Card>
    )
}